import {CoreDI, Device, DI, IAnimation, ILogic, inject, PayAction, ReelConstants, SymbolPosition, WinConfigAnimation, WinPresentationUtils} from '@gongxigames/framework/slot';
import {Pay} from 'com/gongxigames/math/core/game/Pay';
import {GameReelConstants} from 'src/gameReels/GameReelConstants';
import Position = Pay.Position;

export class GameWinPresentationUtils extends WinPresentationUtils {
    @inject(DI.Logic)
    protected _logic!: ILogic;
    @inject(CoreDI.Device)
    protected device!: Device;

    public getSymbolPosition(reel: number, row: number, dimension: number = GameReelConstants.DEFAULT_DIMENSION): SymbolPosition {
        const symsPositions = ReelConstants.REELS[reel].symsPositions[0];

        return {
            x: symsPositions.x,
            y: symsPositions.y + GameReelConstants.DIMENSION_SYMBOL_SLOT_SIZES[dimension].height * row
        };
    }

    public createSymbolSpineAnimationDimension(pos: SymbolPosition, animationConfig: WinConfigAnimation, reelIndex: number, dimension: number = GameReelConstants.DEFAULT_DIMENSION): IAnimation {
        const animation = this.createSymbolSpineAnimation(pos, animationConfig, animationConfig.animation);

        animation.container.y += -ReelConstants.SYMBOL.height / 2 + GameReelConstants.DIMENSION_SYMBOL_SLOT_SIZES[dimension].height / 2;

        return animation;
    }

    public createSymbolAnimation(config: PayAction, symbol: number, pos: Position, animationName = '', dimension: number = GameReelConstants.DEFAULT_DIMENSION): IAnimation {
        const position = this.getSymbolPosition(pos.reel, pos.row, dimension);
        const animationConfig = this.getAnimationConfig(config, symbol, dimension);

        if (animationConfig) {
            if (animationConfig.spine) {
                return this.createSymbolSpineAnimationDimension(position, animationConfig, pos.reel, dimension);
            } else {
                return this.createSymbolTweenAnimation(position, symbol, animationConfig.animation);
            }
        }

        return null!;
    }

    public getAnimationConfig(config: PayAction, symbol: number, dimension = 0): WinConfigAnimation {
        const copyConfig = (object: Object, animationConfig: WinConfigAnimation) => {
            return Object.assign({}, animationConfig, object);
        };

        if (dimension) {
            for (const animationConfig of config.animation) {
                if (symbol + '' === animationConfig.symbol) {
                    const animationConfigDimension = Object.assign(animationConfig);

                    return copyConfig({animation: this.getNameWithDimension(animationConfigDimension.animation, dimension)}, animationConfig);
                }
            }
        }

        return super.getAnimationConfig(config, symbol);
    }

    public getNameWithDimension(animationName: string, dimension: number): string {
        return animationName + dimension + 'x5';
    }
}
